module.exports = __webpack_public_path__ + "img/img_web03_banner1.885f6a82.jpg";